<template>
	<div>
		<TableList :columns="columns" :get_table_list="this.get_table_list" :form_data_seo="form_data_seo"
			:slot_table_list="['operation','status','line_num']" ref="list" :rowKey="'id'">
			<template slot="left_btn">
				<a-button @click="getAddSave('','add')" type="primary">新增工厂</a-button>
				<a-button @click="getAddLine('','add')" type="primary" class='add_line' >新增产线</a-button>
			</template>
			<template slot="status" slot-scope="data">
				<span v-if="data.record.status == 1" class="status_box"
					@click="getMaterialStatus(data.record)">启用</span>
				<span v-else class="status_box" style="background:red;"
					@click="getMaterialStatus(data.record)">禁用</span>
			</template>
			
			
			<template slot="line_num" slot-scope="data">
					<a @click="getLines(data.record)">{{data.record.line_num}}</a>
			</template>
			
			
			<template slot="operation" slot-scope="data">
				
				
				<a @click="getAddSave(data.record,'edit')">编辑</a>
				<a-divider type="vertical" />
				
				<a @click="getAddLine(data.record,'edit')">添加产线</a>
				<a-divider type="vertical" />
				<a @click="getDelete(data.record)">删除</a>
			</template>
		</TableList>

		<!-- 添加或编辑工厂 -->
		<a-modal v-model:visible="factoryShow" :title="factoryFrom.id ? '编辑工厂信息' : '新增工厂信息'" @ok="factoryOk">
			<a-form :label-col="labelColEdit" :wrapper-col="wrapperColEdit">
				<a-form-item required name='name' label="工厂名称"
					:rules="[{ required: true, message: '工厂名称不能为空',tagger:'blur' }]">
					<a-input v-model:value="factoryFrom.factory_name" placeholder="请输入工厂名称" />
				</a-form-item>
				<a-form-item required name='name' label="工厂编号"
					:rules="[{ required: true, message: '工厂编号不能为空',tagger:'blur' }]">
					<a-input v-model:value="factoryFrom.factory_code" placeholder="请输入工厂编号" />
				</a-form-item>
				<a-form-item required name='name' label="工厂ID"
					:rules="[{ required: true, message: '工厂编号不能为空',tagger:'blur' }]">
					<a-input v-model:value="factoryFrom.drp_id" placeholder="请输入工厂ID" />
				</a-form-item>

			
				<a-form-item required name='name' label="工厂负责人">
					<span class="manage_main" v-for="(item,index) in factoryAll" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,1)" />
						</span>
					</span>
					<a @click="add_manage(1)" style="display:inline-block;">选择工厂负责人</a>
				</a-form-item>
				<a-form-item required name='name' label="品控负责人">
					<span class="manage_main" v-for="(item,index) in qualityAll" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,2)" />
						</span>
					</span>
					<a @click="add_manage(2)" style="display:inline-block;">选择品控负责人</a>
				</a-form-item>
				<a-form-item  name='name' label="工厂厂长">
					<span class="manage_main" v-for="(item,index) in chiefManager" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,8)" />
						</span>
					</span>
					<a @click="add_manage(8)" style="display:inline-block;">选择工厂厂长</a>
				</a-form-item>
				
				<a-form-item  name='name' label="工厂副厂长">
					<span class="manage_main" v-for="(item,index) in deputyManager" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,9)" />
						</span>
					</span>
					<a @click="add_manage(9)" style="display:inline-block;">选择工厂副厂长</a>
				</a-form-item>
				<a-form-item name='name' label="品控填表人员">
					<!-- warehouse_director -->
					<span class="manage_main" v-for="(item,index) in addExcelAll" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,6)" />
						</span>
					</span>
					<a @click="add_manage(6)" style="display:inline-block;">选择品控填表人员</a>
				</a-form-item>

				<a-form-item name='name' label="品控管理人员">
					<!-- warehouse_director -->
					<span class="manage_main" v-for="(item,index) in manageExcelAll" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,7)" />
						</span>
					</span>
					<a @click="add_manage(7)" style="display:inline-block;">选择品控管理人员</a>
				</a-form-item>


				<a-form-item name='name' label="生产负责人">
					<span class="manage_main" v-for="(item,index) in produceAll" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,3)" />
						</span>
					</span>
					<a @click="add_manage(3)" style="display:inline-block;">选择生产负责人</a>
				</a-form-item>
				<a-form-item name='name' label="工厂财务">
					<span class="manage_main" v-for="(item,index) in financeAll" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,4)" />
						</span>
					</span>
					<a @click="add_manage(4)" style="display:inline-block;">选择工厂财务</a>
				</a-form-item>

				<a-form-item name='name' label="仓库负责人">
					<!-- warehouse_director -->
					<span class="manage_main" v-for="(item,index) in warehouseAll" :key="index">
						<span class="manage_user">
							{{ item.username }}
							<img src="../../../assets/img/icon_delete.png" @click="manage_delete(index,5)" />
						</span>
					</span>
					<a @click="add_manage(5)" style="display:inline-block;">选择仓库负责人</a>
				</a-form-item>

			</a-form>
		</a-modal>
		<SelectUser ref='select_user' @submit="submit_manage" :visible.sync="visible_manage" select_type="checkbox"></SelectUser>
		<!-- 添加或编辑类型信息 -->
		<a-modal width='30%' v-model:visible="productShow" :title="from.id ? '编辑产线' : '新增产线'" @ok="productOk">
		    <a-form :label-col="labelColEdit" :wrapper-col="wrapperColEdit">
		        <a-form-item required name='name' label="产线名称" :rules="[{ required: true, message: '产线名称不能为空',tagger:'blur' }]">
		            <a-input v-model:value="from.name" placeholder="请输入产线名称" />
		        </a-form-item>
		        <a-form-item required label="所属工厂">
		            <a-select v-model:value="from.factory_id" style="width: 100%" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择" allow-clear>
		                <a-select-option :value="item.id" v-for="(item,index) in FactorySelect" :key="index">{{ item.label }}</a-select-option>
		            </a-select>
		        </a-form-item>
		    </a-form>
		</a-modal>
		
		
		<a-modal width='50%' v-model:visible="productLine" title="产线列表" @ok="productLine=false">
			<productionLine ref='productionLine'  :factory='factory_id'></productionLine>
		</a-modal>
	</div>
</template>
<script>
	import Form from "@/components/Form"
	import productionLine from "../components/productionLine"
	import TableList from "@/components/TableList"
	import SelectUser from "@/components/SelectUser";
	import {
		message,
		Modal
	} from 'ant-design-vue'
	import {
		getFactoryList,
		saveFactoryInfo,
		delFactoryInfo,
		changeFactoryStatus,getFactorySelect,saveLineInfo
		
	} from '@/api/qms.js'
	const columns = [{
			title: "工厂名称",
			dataIndex: "factory_name",
		},
		{
			title: "工厂编码",
			dataIndex: "factory_code",
		},
		{
			title: "工厂ID",
			dataIndex: "drp_id",
		},
		{
			title: "工厂负责人",
			dataIndex: "director_name",
		},
		{
			title: "品控负责人",
			dataIndex: "quality_director_name",
		},
		{
			title: "生产负责人",
			dataIndex: "produce_director_name",
		},
		{
			title: "工厂财务",
			dataIndex: "finance_director_name",
		},
		{
			title: "仓库负责人",
			dataIndex: "warehouse_director_name",
		},
		{
			title: "产线",
			dataIndex: "line_num",
			scopedSlots: {
				customRender: "line_num"
			}
		},
		{
			title: "状态",
			dataIndex: "status",
			scopedSlots: {
				customRender: "status"
			}
		},
		{
			title: "创建时间",
			dataIndex: "create_time",
		},
		{
			title: "操作",
			scopedSlots: {
				customRender: "operation"
			}
		}
	];

	export default {
		name: "Index",
		components: {
			Form,
			TableList,
			SelectUser,
			productionLine
		},
		data() {
			return {
				factory_id:'',
				from:{
				    id:'',
				    name:'',
				},
				productShow:false,
				productLine:false,
				get_table_list: getFactoryList,
				columns,
				form_data_seo: {
					...this.$config.form_data_seo,
					list: [{
						type: "text",
						name: "keyword",
						title: "关键词",
						placeholder: "请输入工厂名称",
						options: {}
					}, ],
				},
				factoryShow: false,
				factoryFrom: {
					id: '',
					factory_name: '',
					factory_code: '',
					director: '',
					quality_director: '',
					produce_director: '',

					fill_form_user: '',
					fill_from_director: '',
					chief_factory_manager: '',
					deputy_factory_manager: '',

				},

				labelColEdit: {
					span: 5
				},
				wrapperColEdit: {
					span: 18
				},

				visible_manage: false,
				selectUserType: 1,

				factoryAll: [],
				qualityAll: [],
				produceAll: [],
				manageExcelAll: [],
				addExcelAll: [],
				financeAll: [],
				warehouseAll: [],
				chiefManager: [],
				deputyManager: [],
				FactorySelect:[],
			};
		},
		created() {

		},
		methods: {
			getLines(info){
				this.productLine= true;
				this.$nextTick(()=>{
					this.$refs.productionLine.where.factory_id  =  info.id;
					this.$refs.productionLine.reset();
				})
				
			},
			productOk(){
			    saveLineInfo({
			        ...this.from
			    }).then(res=>{
			        this.productShow = false
			        message.success('保存成功');
					this.from={}
			        this.$refs.list.get_list()
			    })
			},
			getAddSave(info, type) {
				//清空数据
				this.factoryFrom = {}
				this.factoryAll = []
				this.qualityAll = []
				this.produceAll = []
				this.financeAll = []
				this.warehouseAll = []
				
				this.manageExcelAll = []
				this.addExcelAll = []
				
				this.chiefManager = []
				this.deputyManager = []
				//编辑数据
				if (type == 'edit') {
					let infoData = info
					this.factoryFrom.id = infoData.id
					this.factoryFrom.factory_name = infoData.factory_name
					this.factoryFrom.factory_code = infoData.factory_code
					this.factoryFrom.drp_id = infoData.drp_id
					this.factoryAll = infoData.director_data
					this.qualityAll = infoData.quality_director_data
					this.produceAll = infoData.produce_director_data
					this.financeAll = infoData.finance_director_data
					this.warehouseAll = infoData.warehouse_director_data
					this.manageExcelAll = infoData.fill_from_director_data
					this.addExcelAll = infoData.fill_form_user_data
					this.chiefManager = infoData.chief_factory_manager_data
					this.deputyManager = infoData.deputy_factory_manager_data
				}
				this.factoryShow = true
			},

			factoryOk() {
				//工厂负责人
				let director = []
				for (let i = 0; i < this.factoryAll.length; i++) {
					director.push(this.factoryAll[i].id)
				}
				this.factoryFrom.director = director.length > 0 ? director.join(',') : ''
				//品控负责人
				let quality_director = []
				for (let i = 0; i < this.qualityAll.length; i++) {
					quality_director.push(this.qualityAll[i].id)
				}
				this.factoryFrom.quality_director = quality_director.length > 0 ? quality_director.join(',') : ''
				//生产负责人
				let produce_director = []
				for (let i = 0; i < this.produceAll.length; i++) {
					produce_director.push(this.produceAll[i].id)
				}
				this.factoryFrom.produce_director = produce_director.length > 0 ? produce_director.join(',') : ''
				//仓库负责人
				let warehouse_director = []
				for (let i = 0; i < this.warehouseAll.length; i++) {
					warehouse_director.push(this.warehouseAll[i].id)
				}
				this.factoryFrom.warehouse_director = warehouse_director.length > 0 ? warehouse_director.join(',') : ''
				// 
				let finance_director = []
				for (let i = 0; i < this.financeAll.length; i++) {
					finance_director.push(this.financeAll[i].id)
				}
				this.factoryFrom.finance_director = finance_director.length > 0 ? finance_director.join(',') : ''

				//品控管理
				let fill_from_director = []
				for (let i = 0; i < this.manageExcelAll.length; i++) {
					fill_from_director.push(this.manageExcelAll[i].id)
				}
				this.factoryFrom.fill_from_director = fill_from_director.length > 0 ? fill_from_director.join(',') : ''
				// 
				let fill_form_user = []
				for (let i = 0; i < this.addExcelAll.length; i++) {
					fill_form_user.push(this.addExcelAll[i].id)
				}
				this.factoryFrom.fill_form_user = fill_form_user.length > 0 ? fill_form_user.join(',') : ''



				//厂长
				let chief_factory_manager = []
				for (let i = 0; i < this.chiefManager.length; i++) {
					chief_factory_manager.push(this.chiefManager[i].id)
				}
				this.factoryFrom.chief_factory_manager = chief_factory_manager.length > 0 ? chief_factory_manager.join(',') : ''
				// 副厂长
				let deputy_factory_manager = []
				for (let i = 0; i < this.deputyManager.length; i++) {
					deputy_factory_manager.push(this.deputyManager[i].id)
				}
				this.factoryFrom.deputy_factory_manager = deputy_factory_manager.length > 0 ? deputy_factory_manager.join(',') : ''


				//提交数据
				saveFactoryInfo({
					...this.factoryFrom
				}).then(res => {
					this.factoryShow = false
					message.success('保存成功');
				
					this.$refs.list.get_list()
				})
			},

			getDelete(info) {
				let that = this
				Modal.confirm({
					title: '温馨提示',
					content: '确定要删除工厂【' + info.factory_name + '】吗？',
					okText: '确定',
					cancelText: '取消',
					onOk() {
						delFactoryInfo({
							id: info.id
						}).then(res => {
							message.success('删除成功');
							that.$refs.list.get_list()
						})
					}
				});
			},

			getMaterialStatus(info) {
				let text = info.status == 1 ? "禁用" : "启用"
				let that = this
				Modal.confirm({
					title: '温馨提示',
					content: '确定要' + text + '工厂【' + info.factory_name + '】吗？',
					okText: '确定',
					cancelText: '取消',
					onOk() {
						changeFactoryStatus({
							id: info.id
						}).then(res => {
							message.success('操作成功');
							that.$refs.list.get_list()
						})
					}
				});
			},
			//显示人员选择弹框
			add_manage(type) {
				let obj = []
			if (type == 1) {
				obj=this.factoryAll
			} else if (type == 2) {
				obj=this.qualityAll
			} else if (type == 3) {
				obj=this.produceAll
			} else if (type == 4) {
				obj=this.financeAll
			} else if (type == 5) {
				obj=this.warehouseAll
			} else if (type == 6) {
				obj=this.addExcelAll
			} else if (type == 7) {
				obj=this.manageExcelAll
			}
			else if (type == 8) {
				obj=this.chiefManager
			} else if (type == 9) {
				obj=this.deputyManager
			}
			
				
				this.$refs.select_user.selectedRowKeys = obj.map(item => item.id);
				this.$refs.select_user.select_user_list = obj;
				this.selectUserType = type
				this.visible_manage = true;
			},
			//添加所选人员
			submit_manage({
				data
			}) {
				console.log(data)
				this.visible_manage = false;
				for (let i = 0; i < data.length; i++) {
					let manageData = data.map((it,i)=>{
						return {
						id: data[i].id,
						username: data[i].username
					}
					})
					if (this.selectUserType == 1) {
						this.factoryAll=manageData
					} else if (this.selectUserType == 2) {
						this.qualityAll=manageData
					} else if (this.selectUserType == 3) {
						this.produceAll=manageData
					} else if (this.selectUserType == 4) {
						this.financeAll=manageData
					} else if (this.selectUserType == 5) {
						this.warehouseAll=manageData
					} else if (this.selectUserType == 6) {
						this.addExcelAll=manageData
					} else if (this.selectUserType == 7) {
						this.manageExcelAll=manageData
					}
					else if (this.selectUserType == 8) {
						this.chiefManager=manageData
					} else if (this.selectUserType == 9) {
						this.deputyManager=manageData
					}
				}
			},
			//删除人员选择后的数据
			manage_delete(subscript, type) {
				
				if (type == 1) {
					this.factoryAll.splice(subscript,1)
				} else if (type == 2) {
					let qualityAll = []
					this.qualityAll.splice(subscript,1)
				} else if (type == 3) {
					this.produceAll.splice(subscript,1)
				} else if (type == 4) {
					this.financeAll.splice(subscript,1)
				} else if (type == 5) {
					this.warehouseAll.splice(subscript,1)
				} else if (type == 6) {
					this.addExcelAll.splice(subscript,1)
				} else if (type == 7) {
					this.manageExcelAll.splice(subscript,1)
				}
				else if (type == 9) {
					this.deputyManager.splice(subscript,1)
				} else if (type == 8) {
					this.chiefManager.splice(subscript,1)
				}
			},
			
			getFactorySelect(){
			    getFactorySelect({is_page:0}).then(res=>{
			        this.FactorySelect = res.data.list
			    })
			},
			
			getAddLine(info,type){
				this.getFactorySelect()
				this.from={}
			    //新增
			    if(type == 'add'){
			        this.productFrom = {}
			        this.productShow = true
			    }
			    //编辑数据
			    if(type == 'edit'){
			        this.from.factory_id = info.id
			        this.from.name = info.name
			        this.productShow = true
			    }
			},
		}
	}
</script>

<style lang="less" scoped>
	.status_box {
		background: #1890ff;
		padding: 1px 5px 3px 5px;
		color: #ffffff;
		border-radius: 2px;
		font-size: 12px;
		cursor: pointer;
		display: inline-block;
		min-width: 34px;
	}

	.manage_main {
		margin-right: 10px;
		display: inline-block;

		.manage_user {
			border: 1px #eeeeee solid;
			border-radius: 5px;
			padding: 5px;

			img {
				width: 16px;
				margin-top: -3px;
				cursor: pointer;
			}
		}
	}
	.add_line{
		margin-left: 12px;
	}
</style>